import { Box, Stack, styled, Typography } from '@liscio/ui';

const ActiveDragOverlay = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.action.hover,
  opacity: 0.96,
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: theme.zIndex.tooltip,
}));

const InnerFrame = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: theme.zIndex.tooltip,
  margin: theme.spacing(4),
  border: `1px dashed ${theme.palette.info.dark}`,
  borderRadius: '8px',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ActiveDragOverlayBlue = () => (
  <ActiveDragOverlay>
    <InnerFrame>
      <Typography variant="h4" color="secondary.dark">
        Drop Anywhere
      </Typography>
    </InnerFrame>
  </ActiveDragOverlay>
);
